import { render } from "./VClientTable.vue?vue&type=template&id=3754e888"
import script from "./VClientTable.vue?vue&type=script&lang=js"
export * from "./VClientTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__